import axiosConfig from '../axiosConfig';

export type TSystemScheduleParam = {
	id: number;
	schedule_id: number;
	key: string;
	value: string;
	createdAt: string;
	updatedAt: string;
};
export type TNewSystemScheduleParam = Omit<
	TSystemScheduleParam,
	'id' | 'schedule_id' | 'createdAt' | 'updatedAt'
>;

export type TSystemSchedule = {
	id: number;
	cron: string;
	title: string;
	command: string;
	command_type: string;
	lastRun: string;
	enabled_since: string;
	creator: number;
	updater: number;
	disabled: boolean;
	runLocal: boolean;
	runOnce: boolean;
	createdAt: string;
	updatedAt: string;
	parameters: TSystemScheduleParam[] | TNewSystemScheduleParam[] | undefined;
};
export type TNewSystemSchedule = Omit<TEditSystemSchedule, 'id'> & {
	creator: number;
	updater: number;
};
export type TEditSystemSchedule = Omit<
	TSystemSchedule,
	'createdAt' | 'updatedAt' | 'lastRun' | 'updater' | 'creator'
> & {
	creator: number;
	updater: number;
};
export class SystemSchedule implements TSystemSchedule {
	command_type: string;
	cron: string;
	disabled: boolean;
	enabled_since: string;
	id: number;
	command: string;
	lastRun: string;
	parameters: TSystemScheduleParam[] | TNewSystemScheduleParam[] | undefined;
	runLocal: boolean;
	runOnce: boolean;
	title: string;
	updatedAt: string;
	updater: number;
	createdAt: string;
	creator: number;

	constructor(systemSchedule: TSystemSchedule) {
		this.command_type = systemSchedule.command_type;
		this.createdAt = systemSchedule.createdAt;
		this.creator = systemSchedule.creator;
		this.cron = systemSchedule.cron;
		this.disabled = systemSchedule.disabled;
		this.enabled_since = systemSchedule.enabled_since;
		this.id = systemSchedule.id;
		this.command = systemSchedule.command;
		this.lastRun = systemSchedule.lastRun;
		this.parameters = systemSchedule.parameters;
		this.runLocal = systemSchedule.runLocal;
		this.runOnce = systemSchedule.runOnce;
		this.title = systemSchedule.title;
		this.updatedAt = systemSchedule.updatedAt;
		this.updater = systemSchedule.updater;
	}
	public static Default(): TSystemSchedule {
		return {
			command: '',
			command_type: '',
			cron: '',
			disabled: false,
			enabled_since: '',
			parameters: [],
			runLocal: false,
			runOnce: false,
			title: '',
			createdAt: '',
			creator: 0,
			id: 0,
			lastRun: '',
			updatedAt: '',
			updater: 0,
		};
	}

	public static GetAll(expand: (keyof TSystemSchedule)[] = []): Promise<TSystemSchedule[]> {
		return axiosConfig.instance
			.get<TSystemSchedule[]>('/app/schedules', { params: { expand: expand } })
			.then((res) => {
				return res.data;
			});
	}
	public static GetRequiredParameters(commandType: string): Promise<string[]> {
		return axiosConfig.instance
			.get<string[]>(`/app/schedules/required-params/${commandType}`)
			.then((res) => {
				return res.data;
			});
	}

	static Patch(request: TEditSystemSchedule) {
		return axiosConfig.instance
			.patch<TSystemSchedule>('/app/schedules', request)
			.then((res) => {
				return new SystemSchedule(res.data);
			});
	}

	static Post(request: TNewSystemSchedule) {
		return axiosConfig.instance.post<TSystemSchedule>('/app/schedules', request).then((res) => {
			return new SystemSchedule(res.data);
		});
	}
	static Delete(id: number) {
		return axiosConfig.instance.delete(`/app/schedules/${id}`).then(() => {
			return true;
		});
	}
}

export enum SystemSchedulesCommandTypeEnum {
	ALERT_CHECKER = 'alert_checker',
	SCHEMA_UPDATE = 'schema_update',
	DATA_IMPORT = 'data_import',
	REPORT_SCHEDULE = 'report_schedule',
}

export const SystemSchedulesOptions = [
	{ value: 'Alert Checker', key: 'ALERT_CHECKER' },
	{ value: 'Schedule Update', key: 'SCHEMA_UPDATE' },
	{ value: 'Data Import', key: 'DATA_IMPORT' },
	{ value: 'Report Schedule', key: 'REPORT_SCHEDULE' },
];

export const SystemSchedulesCommandTypeOptionsMap: {
	[key in SystemSchedulesCommandTypeEnum]: string;
} = {
	[SystemSchedulesCommandTypeEnum.ALERT_CHECKER]: 'Alert Checker',
	[SystemSchedulesCommandTypeEnum.SCHEMA_UPDATE]: 'Schedule Update',
	[SystemSchedulesCommandTypeEnum.DATA_IMPORT]: 'Data Import',
	[SystemSchedulesCommandTypeEnum.REPORT_SCHEDULE]: 'Report Schedule',
};
